import { useEffect } from "react";
import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react";

export default function VendorDashboardTable({
  invoiceData,
  loading,
}: any): JSX.Element {


  useEffect(() => {
    // handleGetInvoiceTable();
  }, []);

  return (
    <>
      <Table variant="striped" mt="2rem">
        <Thead>
          <Tr>
            <Th>Status</Th>
            <Th>Count</Th>
          </Tr>
        </Thead>
        <Tbody>
          {loading ? (
            <Tr>
              <Td colSpan={3}>
                <Flex justify="center">
                  <Spinner color={"teal.400"} />
                </Flex>
              </Td>
            </Tr>
          ) : invoiceData?.length === 0 ? (
            <Tr>
              <Td colSpan={3}>
                <Flex justify="center">
                  <Text fontSize="sm">No Data Available to Show</Text>
                </Flex>
              </Td>
            </Tr>
          ) : (
            invoiceData?.map((item: any, index: number) => {
              return (
                <Tr key={index}>
                  <Td fontSize="sm" textTransform="capitalize">
                    {item.status}
                  </Td>
                  {/* <Td fontSize="sm">{item.status}</Td> */}
                  <Td fontSize="sm">{item.count}</Td>
                </Tr>
              );
            })
          )}
        </Tbody>
      </Table>
    </>
  );
}